interface Props {
  highlightColor?: string;
  width?: number;
  height?: number;
}

export const UnavailableIcon = ({ highlightColor, width, height }: Props) => {
  const color = "#00000";

  return (
    <svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 196.87 195.03"
      width={width}
      height={height}
    >
      <title>Unavailable</title>
      <g id="Layer_1-2">
        <path
          fill={highlightColor || color}
          d="m121.45,169.78h-.21c-3.43,0-6.88-.22-10.24-.63-1.37-.17-2.34-1.42-2.18-2.79.17-1.37,1.41-2.34,2.79-2.18,3.16.39,6.4.59,9.64.6h.2c27.39,0,52.77-13.87,67.62-36.6-5.92,1.3-11.96,1.94-18.1,1.94-45.64-.11-82.68-37.33-82.57-82.97.04-14.41,3.76-28.38,10.83-40.76-34.17,9.76-58.44,41.42-58.53,77.45-.03,12.91,2.89,25.25,8.7,36.68.62,1.23.13,2.74-1.1,3.36-1.23.62-2.74.13-3.36-1.1-6.16-12.14-9.27-25.25-9.24-38.96C35.8,43.41,64.56,8.18,104.09.05c1-.2,2.02.21,2.58,1.06.57.84.56,1.95,0,2.79-8.64,12.79-13.22,27.75-13.26,43.26-.1,42.88,34.7,77.85,77.58,77.96,7.77.04,15.35-1.09,22.67-3.3.97-.29,2.03.03,2.67.82.64.79.74,1.89.24,2.78-15.11,27.38-43.88,44.36-75.11,44.36Z"
        />
        <path
          fill={highlightColor || color}
          d="m171.17,130.12h-.2c-45.64-.11-82.68-37.33-82.57-82.97.04-16.5,4.92-32.43,14.12-46.05.77-1.14,2.33-1.44,3.47-.67,1.14.77,1.45,2.33.67,3.47-8.64,12.79-13.22,27.75-13.26,43.26-.1,42.88,34.7,77.85,77.58,77.96h.19c7.66,0,15.22-1.11,22.47-3.3.23-.07.48-.11.72-.11,1.38,0,2.5,1.12,2.5,2.5,0,1.16-.79,2.14-1.87,2.42-7.7,2.31-15.71,3.48-23.83,3.48Z"
        />
        <path
          fill={color}
          d="m182.6,48.75h0l-21.66-.05c-.96,0-1.84-.56-2.25-1.43-.41-.87-.29-1.9.33-2.65l17.33-21.18-16.89-.04c-1.38,0-2.5-1.12-2.49-2.51,0-1.38,1.12-2.49,2.5-2.49h0l22.15.05c.96,0,1.84.56,2.25,1.43.41.87.29,1.9-.33,2.65l-17.33,21.18,16.4.04c1.38,0,2.5,1.12,2.49,2.51,0,1.38-1.12,2.49-2.5,2.49Z"
        />
        <path
          fill={color}
          d="m157.68,88.84h0l-14.57-.04c-.96,0-1.84-.56-2.25-1.43-.41-.87-.29-1.9.33-2.65l10.57-12.92-9.64-.02c-1.38,0-2.5-1.12-2.49-2.51,0-1.38,1.12-2.49,2.5-2.49h0l14.9.04c.96,0,1.84.56,2.25,1.43.41.87.29,1.9-.33,2.65l-10.57,12.92,9.31.02c1.38,0,2.5,1.12,2.49,2.51,0,1.38-1.12,2.49-2.5,2.49Z"
        />
        <path
          fill={color}
          d="m17.55,142.69c-1.22,0-2.29-.89-2.47-2.14-.13-.87-.19-1.75-.19-2.62.02-9.63,7.87-17.45,17.49-17.45h.04c5.14.01,10,2.28,13.32,6.21.89,1.05.76,2.63-.29,3.52-1.05.89-2.63.76-3.52-.29-2.37-2.81-5.84-4.42-9.51-4.43h-.03c-6.87,0-12.47,5.58-12.49,12.46,0,.62.05,1.26.14,1.89.2,1.37-.74,2.64-2.11,2.84-.12.02-.25.03-.37.03Z"
        />
        <path
          fill={color}
          d="m16.4,172.84c-.06,0-.12,0-.18,0-9.1-.65-16.22-8.31-16.22-17.44,0-9.64,7.84-17.49,17.48-17.49h.17c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5h-.17c-6.88,0-12.48,5.6-12.48,12.49,0,6.52,5.08,11.99,11.58,12.45,1.38.1,2.41,1.29,2.32,2.67-.09,1.32-1.19,2.32-2.49,2.32Z"
        />
        <path
          fill={color}
          d="m31.38,187.87c-9.64,0-17.48-7.84-17.48-17.49,0-1.38,1.12-2.52,2.5-2.52s2.5,1.1,2.5,2.48v.04c0,6.89,5.6,12.49,12.48,12.49,2.81,0,5.47-.92,7.68-2.65,1.09-.85,2.66-.66,3.51.43.85,1.09.66,2.66-.43,3.51-3.1,2.42-6.82,3.71-10.76,3.71Z"
        />
        <path
          fill={color}
          d="m103.3,142.57c-.13,0-.27-.01-.41-.03-1.36-.22-2.29-1.51-2.06-2.87.11-.68.17-1.38.17-2.08,0-3.49-1.34-6.76-3.8-9.23-2.46-2.47-5.73-3.83-9.22-3.84h-.03c-5.34,0-10.21,3.33-12.15,8.29-.35.96-1.27,1.65-2.35,1.65-1.38,0-2.5-1.12-2.5-2.5v-.47l.17-.44c2.67-6.91,9.43-11.54,16.84-11.54h.04c4.82.01,9.35,1.9,12.75,5.31s5.27,7.95,5.25,12.77c0,.97-.08,1.94-.24,2.88-.2,1.23-1.26,2.09-2.46,2.09Z"
        />
        <path
          fill={color}
          d="m87.88,188.39h-.04c-4.87-.01-9.43-1.93-12.84-5.41-.97-.99-.95-2.57.04-3.54.99-.97,2.57-.95,3.54.04,2.46,2.51,5.76,3.9,9.28,3.91h.03c7.05,0,12.89-5.72,13.04-12.76.03-1.38,1.15-2.52,2.55-2.45,1.38.03,2.48,1.17,2.45,2.55-.21,9.74-8.3,17.66-18.04,17.66Z"
        />
        <path
          fill={color}
          d="m103.42,173.18c-1.18,0-2.24-.84-2.46-2.05-.25-1.36.65-2.66,2.01-2.91,2.49-.46,4.78-1.62,6.61-3.37,2.62-2.48,4.07-5.83,4.07-9.44.02-6.37-4.52-11.79-10.79-12.88-1.36-.24-2.27-1.53-2.03-2.89.24-1.36,1.54-2.27,2.89-2.03,8.67,1.51,14.95,9.01,14.93,17.82-.01,4.99-2.01,9.63-5.63,13.05-2.54,2.41-5.71,4.03-9.16,4.66-.15.03-.3.04-.45.04Z"
        />
        <path
          fill={color}
          d="m58.37,195.03h-.06c-8.31-.02-16.01-4.53-20.09-11.77-.68-1.2-.25-2.73.95-3.41,1.2-.68,2.73-.25,3.41.95,3.2,5.67,9.24,9.21,15.75,9.23h.05c6.87,0,13.07-3.8,16.18-9.94.62-1.23,2.13-1.73,3.36-1.1,1.23.62,1.72,2.13,1.1,3.36-3.96,7.82-11.87,12.68-20.64,12.68Z"
        />
        <path
          fill={color}
          d="m73.45,134.45s-.02,0-.04,0c-1.37-.02-2.47-1.13-2.47-2.5v-.42c.02-6.89-5.57-12.51-12.45-12.52h-.03c-3.61,0-7.04,1.56-9.42,4.29-1.38,1.58-2.34,3.5-2.79,5.54-.29,1.35-1.62,2.21-2.97,1.92-1.35-.29-2.21-1.62-1.92-2.97.62-2.87,1.97-5.56,3.9-7.77,3.32-3.82,8.12-6.01,13.19-6.01h.04c9.64.02,17.47,7.89,17.45,17.53,0,.16,0,.32,0,.48-.04,1.36-1.15,2.43-2.5,2.43Z"
        />
      </g>
    </svg>
  );
};
